<template>
  <div class="">
    <v-menu
      v-model="showDatePickerMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          color="secondary"
          outlined
          small
          v-bind="attrs"
          v-on="on"
        >
          <v-avatar left>
            <v-icon small>mdi-file-clock-outline</v-icon>
          </v-avatar>
          Aktiv månadsfaktureringsplan
        </v-chip>
      </template>
      <v-card max-width="500">
        <v-alert
          class="ma-0 d-flex"
          type="info"
          text
        >
          <div class="d-flex flex-column">
            <div class="pr-6">
              {{ invoicingScheduleDescription }}
            </div>
            <v-btn
              @click="cancelMonthlyInvoicing"
              :loading="isCancellingInvoicingSchedule"
              class="ml-auto mt-4"
              text
              color="error"
            >
              Avbryt månadsfakturering
            </v-btn>
          </div>
        </v-alert>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import InvoiceService from '@/services/InvoiceService.js'

export default {
  name: 'RecurringInvoicingStatus',
  components: {},
  props: {
    invoicingSchedule: Object
  },
  data: () => ({
    showDatePickerMenu: false,
    isCancellingInvoicingSchedule: false
  }),
  computed: {
    ...mapState(
      {
        /*  */
      }
    ),
    invoicingScheduleDescription: function () {
      if (!this.invoicingSchedule) {
        return ''
      }
      // Den här bokningen har en aktiv månadsfaktureringsplan. {{ booking.invoicing_schedule.installments_count - booking.invoicing_schedule.installments_processed }} av {{ booking.invoicing_schedule.installments_count }} fakturor återstår i månadsfaktureringsplanen.
      let description = 'Månadsfakturering pågår. '
      description += `${this.invoicingSchedule.installments_processed} av ${this.invoicingSchedule.installments_count} fakturor har skapats. `
      if (this.invoicingSchedule.next_invoice_date) {
        description += `Nästa faktura skapas ${this.invoicingSchedule.next_invoice_date.toHumanReadableDate({ longFormat: true, capitalized: false })}. `
      }
      return description
    }
  },
  methods: {
    cancelMonthlyInvoicing: function () {
      this.$store.commit('SET_OPEN_CONFIRMATION_DIALOG', {
        header: 'Avbryt månadsfakturering',
        body: 'Är du säker på att du vill avbryta månadsfaktureringsplanen för den här bokningen? Inga fler fakturor kommer att skapas automatiskt.',
        confirmationFunction: this.confirmCancelMonthlyInvoicing,
        confirmationArgument: this.invoicingSchedule.booking_id
      })
    },
    confirmCancelMonthlyInvoicing: function (bookingId) {
      this.isCancellingInvoicingSchedule = true
      InvoiceService.cancelInvoicingSchedule({ bookingId })
        .then(({ data }) => {
          if (data.status === 'success') {
            this.$store.commit('booking/TRIGGER_BOOKING_UPDATED')
            window.enrich.enrichBooking(data.data.booking)
            if (bookingId === this.$store.state.booking.dialog.bookingId) {
              this.$store.commit('booking/SET_DIALOG_BOOKING', data.data.booking)
            }
          }
        })
        .finally(() => {
          this.isCancellingInvoicingSchedule = false
        })
    }
  },
  watch: {
    /*  */
  },
  mounted () {}
}
</script>
